module.exports = __webpack_public_path__ + "img/hot.b0209485.svg";